/* Elmont Row — camada JS (prefixo __er / er-). Sem dependências. */
(function () {
  'use strict';
  if (window.__erLoaded) return;
  window.__erLoaded = true;

  var cfg = window.__erConfig || {};
  var CUTOFF_HOUR = cfg.cutoffHour != null ? cfg.cutoffHour : 14;
  var DISPATCH_DAYS = cfg.dispatchDays != null ? cfg.dispatchDays : 2;
  var DELIVERY_MIN = cfg.deliveryMin != null ? cfg.deliveryMin : 3;
  var DELIVERY_MAX = cfg.deliveryMax != null ? cfg.deliveryMax : 5;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function londonNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return new Date(+o.year, +o.month - 1, +o.day, +o.hour % 24, +o.minute);
    } catch (e) { return new Date(); }
  }
  function addBusinessDays(d, n) {
    var r = new Date(d.getTime()); var added = 0;
    while (added < n) { r.setDate(r.getDate() + 1); var wd = r.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return r;
  }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }

  function initDelivery() {
    var els = document.querySelectorAll('[data-er-delivery]');
    if (!els.length) return;
    var now = londonNow();
    var afterCutoff = now.getHours() >= CUTOFF_HOUR;
    var start = afterCutoff ? addBusinessDays(now, 1) : now;
    var dispatch = addBusinessDays(start, DISPATCH_DAYS);
    var d1 = addBusinessDays(dispatch, DELIVERY_MIN), d2 = addBusinessDays(dispatch, DELIVERY_MAX);
    els.forEach(function (el) {
      var range = el.querySelector('[data-er-range]'); if (range) range.textContent = fmt(d1) + ' – ' + fmt(d2);
      var cd = el.querySelector('[data-er-countdown]');
      if (cd) {
        function tick() {
          var n = londonNow();
          var cut = new Date(n.getFullYear(), n.getMonth(), n.getDate(), CUTOFF_HOUR, 0, 0);
          if (n >= cut) { cd.textContent = 'Order today and it leaves us within ' + DISPATCH_DAYS + ' working days.'; return; }
          var ms = cut - n, h = Math.floor(ms / 36e5), m = Math.floor((ms % 36e5) / 6e4);
          cd.textContent = 'Order within ' + (h ? h + 'h ' : '') + m + 'm for dispatch within ' + DISPATCH_DAYS + ' working days.';
        }
        tick(); setInterval(tick, 30000);
      }
    });
  }

  function initSticky() {
    var host = document.querySelector('[data-er-sticky]');
    if (!host) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var btn = form.querySelector('button[type="submit"], [type="submit"]');
    if (!btn) return;
    var bar = document.createElement('div');
    bar.className = 'er-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="er-sticky__inner">' +
      (host.dataset.image ? '<img class="er-sticky__img" src="' + host.dataset.image + '" alt="">' : '') +
      '<div class="er-sticky__info"><p class="er-sticky__title">' + (host.dataset.title || '') + '</p><p class="er-sticky__price" data-er-sticky-price>' + (host.dataset.price || '') + '</p></div>' +
      '<button type="button" class="er-btn" data-er-sticky-btn>' + (host.dataset.label || 'Add to bag') + '</button></div>';
    document.body.appendChild(bar);
    bar.querySelector('[data-er-sticky-btn]').addEventListener('click', function () {
      if (btn.disabled) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      btn.click();
    });
    var priceEl = document.querySelector('[data-er-sticky-price]');
    function syncState() {
      var sb = bar.querySelector('[data-er-sticky-btn]');
      var txt = (btn.textContent || '').trim();
      sb.textContent = btn.disabled ? (txt || 'Sold out') : (host.dataset.label || txt || 'Add to bag');
      sb.disabled = false;
      var themePrice = document.querySelector('.price, [class*="price"] [class*="regular"], [data-price]');
      if (priceEl && themePrice && themePrice.textContent.trim()) priceEl.textContent = themePrice.textContent.replace(/\s+/g, ' ').trim().slice(0, 40);
    }
    syncState();
    new MutationObserver(syncState).observe(form, { subtree: true, childList: true, characterData: true, attributes: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > window.innerHeight;
        bar.classList.toggle('is-visible', !visible);
        document.body.classList.toggle('er-sticky-open', !visible);
        bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { threshold: 0 }).observe(btn);
    }
  }

  function initCartNoLink() {
    if (!cfg.cartNoLink) return;
    function apply(root) {
      var scope = root || document;
      scope.querySelectorAll('cart-items-component, .cart-items, .cart-drawer, cart-drawer-component, [class*="cart-item"], [id*="cart"]').forEach(function (c) {
        c.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
          if (a.dataset.erNolink) return;
          a.dataset.erNolink = '1';
          a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
          a.style.pointerEvents = 'none'; a.style.cursor = 'default'; a.removeAttribute('href');
        });
      });
    }
    apply();
    new MutationObserver(function () { apply(); }).observe(document.body, { subtree: true, childList: true });
  }

  function initNewsletter() {
    if (location.search.indexOf('customer_posted=true') === -1) return;
    var f = document.querySelector('.er-newsletter__form');
    if (f) { var ok = document.createElement('p'); ok.className = 'er-newsletter__success'; ok.textContent = 'Thank you — you are on the list.'; f.parentNode.insertBefore(ok, f.nextSibling); }
  }

  ready(function () { initDelivery(); initSticky(); initCartNoLink(); initNewsletter(); });
  document.addEventListener('shopify:section:load', function () { initDelivery(); });
})();
